// extracted by mini-css-extract-plugin
export var falconContainer = "_vb-2";
export var offerCenter = "_vb-0";
export var roktContainer = "_vb-1";